// @flow
import type { LeafRuleProps } from 'types/rule-types';
import type { StoreState } from 'reducers';

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Label } from 'semantic-grab-ui/src';
import DynamicHeightFormSelect from 'components/form/DynamicHeightFormSelect';
import _ from 'lodash';
import DatePicker from 'react-datepicker';

const DATE_TIME_FORMAT = 'DD/MM/YYYY hh:mm a';
const TIME_FORMAT = 'hh:mm a';
const DEFAULT_STEP_UP_RHS = {
  time: parseInt(moment().format('X'), 10),
  serviceTypeIDs: [],
  rides: 0,
};

export class StepUpRule extends Component {
  props: any;

  constructor(props: LeafRuleProps) {
    super(props);
    this.state = {
      rhs: _.get(props, 'rule.rhs'),
    };
  }

  componentDidMount() {
    if (_.isEmpty(_.get(this.props, 'rule.rhs'))) {
      const { rule } = this.props;
      rule.rhs = DEFAULT_STEP_UP_RHS;
      this.props.onRuleChange(rule);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Object) {
    this.setState({ rhs: _.get(nextProps, 'rule.rhs') });
  }

  handleRhsChangeDateTime = (value: Object) => {
    const { rule } = this.props;
    rule.rhs.time = parseInt(moment(value).format('X'), 10) || DEFAULT_STEP_UP_RHS.time;
    this.props.onRuleChange(rule);
  }

  handleTaxiTypeIDChange = (event: any, data: any) => {
    const { rule } = this.props;
    rule.rhs.serviceTypeIDs = _.get(event, 'target.value') || _.get(data, 'value');
    this.props.onRuleChange(rule);
  }

  handleClearTaxiTypeIDs = () => {
    const { rule } = this.props;
    rule.rhs.serviceTypeIDs = [];
    this.props.onRuleChange(rule);
  }

  handleRidesChange = (event: any, data: any) => {
    const { rule } = this.props;
    rule.rhs.rides = parseInt(_.get(event, 'target.value') || _.get(data, 'value'), 10) || DEFAULT_STEP_UP_RHS.rides;
    this.props.onRuleChange(rule);
  }

  render() {
    const { isSelected, rule, cityIDs, taxiTypes } = this.props;
    const { serviceTypeIDs = [], rides, time: from } = rule.rhs;
    const fromTime = moment.unix(from);
    const taxiTypeIDsOptions = _.sortBy(_.map(
      _.filter(taxiTypes, (taxiType) => _.includes(cityIDs, taxiType.cityID)),
      taxiType => ({
        key: taxiType.taxiTypeID,
        value: taxiType.taxiTypeID,
        text: `${taxiType.cityCode} | ${taxiType.name}` })
    ),
    ['text']);

    const taxiTypeField = (
      <Form.Field className="promotions-taxi-types-ids-wrapper required">
        <span className="taxi-types-ids-select-wrapper__count">({serviceTypeIDs.length} Selected)</span>
        <a className="taxi-types-ids-select-wrapper__clear-all" onClick={this.handleClearTaxiTypeIDs}>Clear all</a>
        <DynamicHeightFormSelect
          id="taxi-types-ids-tags"
          search
          multiple
          selection
          allowAdditions
          options={taxiTypeIDsOptions}
          value={serviceTypeIDs}
          onChange={this.handleTaxiTypeIDChange}
        />
      </Form.Field>
    );

    if (!isSelected) {
      return (
        <span>
          {`${rides} Rides on  `}
          { _.map(serviceTypeIDs, taxiTypeID => (
            <Label key={taxiTypes[taxiTypeID].name}>{taxiTypes[taxiTypeID].name}</Label>
          )) }
          <p>{`Since ${fromTime.format(DATE_TIME_FORMAT)}`}</p>
        </span>
      );
    }
    return (
      <span>
        <Form.Field>
          <Input
            name={`${rule.uid}-input`}
            value={this.state.rhs.rides}
            onBlur={this.handleRidesChange}
            onChange={this.handleRidesChange}
          />
        </Form.Field>
        {' Rides on  '}
        {taxiTypeField}
        {'Since  '}
        <Form.Input
          control={DatePicker}
          selected={fromTime}
          onChange={(val) => this.handleRhsChangeDateTime(val)}
          showTimeSelect
          timeIntervals={15}
          dateFormat={DATE_TIME_FORMAT}
          timeFormat={TIME_FORMAT}
        />
      </span>
    );
  }
}

export function mapStateToProps(state: StoreState, ownProps: Object) {
  return {
    ...ownProps,
    taxiTypes: state.countries.taxiTypeHash,
  };
}

export default connect(mapStateToProps)(StepUpRule);
